import type { Uuid } from 'shared/common/types';
import type { ProjectState } from '../project.state';
import { createSelector } from '@ngrx/store';
import * as fromGoods from 'app/store/project/goods/goods.reducer';
import { selectProjectState } from '../project.state';

export const goodsState = createSelector(
  selectProjectState,
  state => state.goods,
);

export const goods = createSelector(
  selectProjectState,
  (state: ProjectState) => fromGoods.selectAll(state.goods),
);

export const goodEntities = createSelector(
  selectProjectState,
  state => fromGoods.selectEntities(state.goods),
);

export const oneGood = createSelector(
  selectProjectState,
  (state: ProjectState, props: { id: Uuid }) => fromGoods.selectEntities(state.goods)[props.id],
);

export const goodsLoading = createSelector(
  selectProjectState,
  state => state.goods.loading,
);
